import React from 'react';
import styled from 'astroturf/react';

const Anchor = styled.a`
  word-break: break-all;
  color: $ds-primary-blue-active;

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

const LinkAnchor = styled(Anchor)`
  cursor: pointer;
`;

export const Link: React.FC<
  React.AnchorHTMLAttributes<HTMLAnchorElement> & { linked?: boolean }
> = ({ href, children, linked = true, ...props }) => {
  if (linked) {
    return (
      <LinkAnchor href={href} {...props}>
        {children}
      </LinkAnchor>
    );
  } else {
    return <Anchor {...props}>{children}</Anchor>;
  }
};
